import React from 'react'
import AboutBreadCrumb from './AboutBreadCrumb';
import AboutUs from './AboutUs'
function AboutUsPage() {
    return ( 
        <>
        <AboutBreadCrumb />
        <AboutUs />
        </>
     );
}

export default AboutUsPage;